import React, { useState } from 'react';
import { roles } from '../../../services/AuthService';
import { useStateValue } from '../../../services/ContextProvider';
import { updateUserRole, userRoleReadable } from '../../../services/userService';
import Button from '../../Button/Button';
import './AdminPanelUserTile.scss';

const AdminPanelUserTile = ({ user }) => {

  const [currentRole, setCurrentRole] = useState(user.role);
  const { userState, userDispatch } = useStateValue();
  const [isUpdateLoading, setisUpdateLoading] = useState(false);

  const handleRoleUpdate = async () => {
    setisUpdateLoading(true);
    await updateUserRole(user.uid, currentRole, userState, userDispatch);
    setisUpdateLoading(false);
  };

  if (!user) {
    return (<div>No info</div>);
  }

  return (
    <div className='AdminPanelUserTile'>
      <div className="ap-user-tile-detail-section">
        <div className="ap-user-tile-image-container">
          <img src={user.photoURL} alt={user.displayName} className="ap-user-image" />
        </div>
        <div className="ap-user-tile-name-section">
          <div className="ap-user-name">{user.displayName}</div>
          <div className="ap-user-role">{userRoleReadable(user.role)}</div>
          <div className="ap-user-role">{user.email}</div>
        </div>
        <div className="ap-user-update-section">
          <select value={currentRole} onChange={(e) => setCurrentRole(e.target.value)}>
            {
              Object.values(roles).map(e => (
                <option key={e} value={e}>{userRoleReadable(e)}</option>
              ))
            }
          </select>
          {!isUpdateLoading &&
            <Button
              buttonColour={user.role === currentRole ? 'light-grey' : 'grey'}
              buttonType={user.role === currentRole ? 'outline' : 'primary'}
              isDissabled={user.role === currentRole}
              onClick={handleRoleUpdate}
            >Update</Button>
          }
          {isUpdateLoading &&
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          }
        </div>
      </div>

    </div>
  );
};

export default AdminPanelUserTile;
